const getters = {
    planCart: state => state.planCart,
    planStatus: state => state.planStatus,
    planErrors: state => state.planErrors,
    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,
    plans: state => state.plans,
    plansCount: state => state.plansCount,
    planDetailById: state => id => {
        return state.plans.find(plan => plan.plan_id === id);
    },
};

export default getters;
